import "../styles/globals.css";
import "react-toastify/dist/ReactToastify.css";

import Navbar from "@/components/layouts/nav";

import { WagmiConfig, createClient, configureChains } from "wagmi";
import { publicProvider } from "wagmi/providers/public";
import { MetaMaskConnector } from "wagmi/connectors/metaMask";
import { WalletConnectConnector } from "wagmi/connectors/walletConnect";
import { TorusConnector, UpbondConnector } from "src/config";
import { ToastContainer } from "react-toastify";
import { polygon, polygonMumbai } from "@wagmi/core/chains";

function MyApp({ Component, pageProps }) {
  const { chains, provider, webSocketProvider } = configureChains([polygon, polygonMumbai], [publicProvider()]);

  const client = createClient({
    autoConnect: true,
    connectors: [
      new MetaMaskConnector({ chains }),
      new WalletConnectConnector({
        chains,
        options: {
          qrcode: true,
          chainId: 137,
        },
      }),
      new TorusConnector({
        chains,
        options: {
          buildEnv: "testing",
          enableLogging: true,
          buttonPosition: "bottom-left",
          showTorusButton: true,
        },
      }),
      new UpbondConnector({
        chains,
        options: {
          buildEnv: "development",
          enableLogging: true,
          buttonPosition: "bottom-left",
          showTorusButton: true,
        },
      })
    ],
    provider,
    webSocketProvider,
  });
  return (
    <>
      <WagmiConfig client={client}>
        <Navbar />
        <Component {...pageProps} />
        <ToastContainer position="top-right" autoClose={6000} closeOnClick pauseOnHover />
      </WagmiConfig>
    </>
  );
}

export default MyApp;
